export default __webpack_public_path__ + "static/media/Squares_04.d8890347.png";